import { Directive, HostBinding, Input } from "@angular/core";
import { AbstractControl } from "@angular/forms";

@Directive({
  selector: '[tagFormFieldState]'
})
export class TagFormFieldStateDirective {
  @Input('tagFormFieldState') control: AbstractControl

  @HostBinding('class.interval-tag-required')
  get intervalRequiredClass(): boolean {
    if (!this.control) return false;
    const ctlr = this.control
    return !(ctlr.touched && ctlr.invalid) && (ctlr.hasError('required') || ctlr.hasError('tagRequired'))
  }

  @HostBinding('class.interval-tag-completed')
  get intervalCompletedClass(): boolean {
    if (!this.control) return false;
    const ctlr = this.control
    return ctlr.value !== null && ctlr.value !== '' && ctlr.value !== undefined && !ctlr.hasError('required') && !ctlr.hasError('tagRequired')
  }

  @HostBinding('class.interval-tag-error')
  get intervalErrorClass() {
    if (!this.control) return false
    const ctlr = this.control
    return ctlr.touched && (ctlr.hasError('required') || ctlr.hasError('tagRequired'))
  }
}